import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    withdrawalAmountHeader: {
        id: '_.choose_loan_amount.withdrawal_amount_header',
        defaultMessage: 'I want to borrow {input}'
    },
    borrowAmountHeader: {
        id: '_.choose_loan_amount.borrow_amount_header',
        defaultMessage: 'How much would you like to borrow? {input}'
    }
});
